import React, { useState, useEffect } from "react";
import { redirect, useNavigate } from "react-router-dom";
import Cell from "../assets/Cell.svg";
import { FaArrowLeft } from "react-icons/fa";
import { FcHighPriority } from "react-icons/fc";
// Import images
import verifiedIcon from "../assets/Verified.svg"; // Update the path to your "verified" image
import notVerifiedIcon from "../assets/Notverified.svg"; // Update the path to your "not verified" image
import { toast, ToastContainer } from "react-toastify";
import { validateToken } from "../tokenValidation";
import secureStorage from "../utils/secureStorage";
const Viewallcustomers = () => {
  const [customers, setCustomers] = useState([]);
  const [filteredCustomers, setFilteredCustomers] = useState([]);
  const [searchQuery, setSearchQuery] = useState("");
  const [pageNumber, setPageNumber] = useState(0);
  const [pageSize] = useState(10); // Default page size
  const [totalPages, setTotalPages] = useState(0);
  const [loading, setLoading] = useState(false);
  const API_URL = process.env.REACT_APP_API_URL;

  const [modalOpen, setModalOpen] = useState(false);
  const [selectedCustomer, setSelectedCustomer] = useState(null);
  const [documentType, setDocumentType] = useState("");
  const [aboutDocument, setAboutDocument] = useState("");
  const [practitioners, setPractitioners] = useState([]);
  const [selectedPractitioner, setSelectedPractitioner] = useState("");
  const [selectedFile, setSelectedFile] = useState(null);
  const [debounceTimeout, setDebounceTimeout] = useState(null);

  const [subCentres, setSubCentres] = useState([]);
  const [selectedSubCentre, setSelectedSubCentre] = useState("");

  const navigate = useNavigate();

  const fetchCustomers = async () => {
    setLoading(true);
    try {
      const token = secureStorage.get("authToken");
      const clinicId = secureStorage.get("clinic");
      if (!token) {
        console.error("Authentication token not found. Please log in again.");
        return;
      }

      const orgId = secureStorage.get("orgId");
      const response = await fetch(
        `${API_URL}hospital/patients?pageNumber=${pageNumber}&pageSize=${pageSize}&orgId=${encodeURIComponent(orgId)}`,
        {
          method: "GET",
          headers: {
            Authorization: `Bearer ${token}`,
            "Content-Type": "application/json",
            "X-HIP-ID": clinicId,
          },
        }
      );

      if (response.ok) {
        const data = await response.json();
        setCustomers(data.data.content || []);
        setFilteredCustomers(data.data.content || []);
        setTotalPages(data.data.totalPages || 0);
      } else {
        console.error("Failed to fetch customers:", response.statusText);
      }
    } catch (error) {
      console.error("Error fetching customers:", error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    const fetchSubcentres = async () => {
      try {
        const token = secureStorage.get("authToken");
        const clinicId = secureStorage.get("clinic");
        const orgId = secureStorage.get("orgId");

        const resp = await fetch(
          `${API_URL}hospital/get-subcentres?orgId=${encodeURIComponent(orgId)}`,
          {
            method: "GET",
            headers: {
              "Content-Type": "application/json",
              "X-HIP-ID": clinicId,
              Authorization: `Bearer ${token}`,
            },
          }
        );
        if (!resp.ok) throw new Error("Failed to fetch subcentres");
        const json = await resp.json();
        const facilities = json.data?.facilityDetails || [];
        setSubCentres(facilities);

        const defaultFacility =
          facilities.find(f => f.hipId === clinicId) || facilities[0];
        if (defaultFacility?.hipId) setSelectedSubCentre(defaultFacility.hipId);
      } catch (e) {
        console.error(e);
      }
    };

    fetchSubcentres();
  }, [API_URL]);


  useEffect(() => {
    validateToken(navigate);
  }, [navigate]);

  useEffect(() => {
    fetchCustomers();
  }, [pageNumber]);

  const handleSearch = async (query) => {
    setSearchQuery(query);

    if (debounceTimeout) {
      clearTimeout(debounceTimeout);
    }

    const newDebounceTimeout = setTimeout(async () => {
      if (query.trim() === "") {
        fetchCustomers();
        return;
      }

      try {
        const token = secureStorage.get("authToken");
        if (!token) {
          console.error("Authentication token not found. Please log in again.");
          return;
        }
        const orgId = secureStorage.get("orgId");
        const response = await fetch(
          `${API_URL}hospital/patients-by-filter?filter=${query}&orgId=${orgId}`,
          {
            method: "GET",
            headers: {
              Authorization: `Bearer ${token}`,
              "Content-Type": "application/json",
            },
          }
        );

        if (response.ok) {
          const data = await response.json();
          setFilteredCustomers(data.data || []);
        } else {
          console.error(
            "Failed to fetch filtered customers:",
            response.statusText
          );
        }
      } catch (error) {
        console.error("Error fetching filtered customers:", error);
      }
    }, 800); // Set delay (800ms after the user stops typing)

    setDebounceTimeout(newDebounceTimeout);
  };

  const handleClick = (data) => {
    navigate("/Viewrecord", { state: { data } });
  };

  const handleClickconsent = (data) => {
    navigate("/consent", { state: { data } });
  };

  const handleClickProfile = (preferredAbhaAddress) => {
    navigate("/patient-profile", { state: { abhaAddress: preferredAbhaAddress } });
  };

  const [uploading, setUploading] = useState(false);
  // const handleUpload = async () => {
  //   setUploading(true);
  //   if (
  //     !documentType ||
  //     !selectedFile ||
  //     !aboutDocument
  //   ) {
  //     toast.error("Please fill all fields before uploading.");
  //     return;
  //   }
  //   const apiDocumentType = documentTypeMapping[documentType];

  //   const formData = new FormData();
  //   formData.append("file", selectedFile);
  //   // formData.append("aboutDocument", aboutDocument);

  //   try {
  //     const token = secureStorage.get("authToken");
  //     if (!token) {
  //       console.error("Authentication token not found. Please log in again.");
  //       return;
  //     }

  //     const response = await fetch(
  //       `${API_URL}abdm-data-share/upload?patientId=${selectedCustomer.patientId}&documentType=${apiDocumentType}&practitionerId=${selectedPractitioner}&aboutDocument=${aboutDocument}`,

  //       {
  //         method: "POST",
  //         headers: {
  //           Authorization: `Bearer ${token}`,
  //           "X-HIP-ID": secureStorage.get("clinic"),
  //         },
  //         body: formData,
  //       }
  //     );

  //     if (response.status === 200) {
  //       toast.success("Document uploaded successfully!");
  //       setModalOpen(false);
  //       setSelectedCustomer(null);
  //       setDocumentType("");
  //       setSelectedFile(null);
  //       setSelectedPractitioner("");
  //       setAboutDocument("");
  //     } else {
  //       console.error("Failed to upload document:", response.statusText);
  //       toast.error("Failed to upload document.");
  //     }
  //   } catch (error) {
  //     console.error("Error uploading document:", error);
  //     toast.error("Error uploading document.");
  //   } finally {
  //     setUploading(false);
  //   }
  // };

  const handleUpload = async () => {
    setUploading(true);
    if (!documentType || !selectedFile || !aboutDocument) {
      toast.error("Please fill all fields before uploading.");
      setUploading(false);
      return;
    }
    if (!selectedSubCentre) {
      toast.error("Please select an Organization.");
      setUploading(false);
      return;
    }

    const apiDocumentType = documentTypeMapping[documentType];
    const formData = new FormData();
    formData.append("file", selectedFile);

    try {
      const token = secureStorage.get("authToken");
      if (!token) {
        console.error("Authentication token not found. Please log in again.");
        setUploading(false);
        return;
      }

      const url = `${API_URL}abdm-data-share/upload` +
        `?patientId=${encodeURIComponent(selectedCustomer.patientId)}` +
        `&documentType=${encodeURIComponent(apiDocumentType)}` +
        `&hipId=${encodeURIComponent(selectedSubCentre)}` +
        `&aboutDocument=${encodeURIComponent(aboutDocument)}` +
        (selectedPractitioner ? `&practitionerId=${encodeURIComponent(selectedPractitioner)}` : "");

      const response = await fetch(url, {
        method: "POST",
        headers: {
          Authorization: `Bearer ${token}`,
          // keep caller’s clinic in header if your gateway/auth expects it
          "X-HIP-ID": secureStorage.get("clinic"),
        },
        body: formData,
      });

      if (response.status === 200) {
        toast.success("Document uploaded successfully!");
        setModalOpen(false);
        setSelectedCustomer(null);
        setDocumentType("");
        setSelectedFile(null);
        setSelectedPractitioner("");
        setAboutDocument("");
      } else {
        console.error("Failed to upload document:", response.statusText);
        toast.error("Failed to upload document.");
      }
    } catch (error) {
      console.error("Error uploading document:", error);
      toast.error("Error uploading document.");
    } finally {
      setUploading(false);
    }
  };


  const closeModal = () => {
    setModalOpen(false);
    setSelectedCustomer(null);
    setDocumentType("");
    setSelectedFile(null);
    setSelectedPractitioner("");
    setAboutDocument("");
  };
  const handleUploadClick = (customer) => {
    setSelectedCustomer(customer);
    setModalOpen(true);
    // if no selection yet, try to default to current clinic or first subcentre
    if (!selectedSubCentre) {
      const clinicId = secureStorage.get("clinic");
      const defaultFacility =
        subCentres.find(f => f.hipId === clinicId) || subCentres[0];
      if (defaultFacility?.hipId) setSelectedSubCentre(defaultFacility.hipId);
    }
  };


  const handleFileChange = (e) => {
    setSelectedFile(e.target.files[0]);
  };

  const documentTypeMapping = {
    Prescription: "Prescription",
    "Diagnostic Report": "DiagnosticReport",
    "OP Consultation": "OPConsultation",
    "Discharge Summary": "DischargeSummary",
    "Immunization Record": "ImmunizationRecord",
    "Health Document Record": "HealthDocumentRecord",
    "Wellness Record": "WellnessRecord",
    Invoice: "Invoice",
  };

  useEffect(() => {
    if (!modalOpen) return;
    const run = async () => {
      try {
        const token = secureStorage.get("authToken");
        const orgId = secureStorage.get("orgId");
        if (!token) return;
        const resp = await fetch(`${API_URL}hospital/get-active-practitioners?orgId=${orgId}`, {
          method: "GET",
          headers: {
            Authorization: `Bearer ${token}`,
            "Content-Type": "application/json",
            "X-HIP-ID": selectedSubCentre || secureStorage.get("clinic"),
          },
        });
        if (resp.ok) {
          const data = await resp.json();
          setPractitioners(data.data || []);
        }
      } catch (e) {
        console.error("Error fetching practitioners:", e);
      }
    };
    run();
  }, [API_URL, modalOpen, selectedSubCentre]);


  const redirectTo = async (abhaNo) => {
    navigate(`/abhalogin?queryParam=${abhaNo}`);
  };

  const redirectToSignup = async () => {
    navigate(`/abhalogin`);
  }

  return (
    <div className="bg-[#F6F6F6] min-h-screen p-6">
      <div className="flex items-center justify-between mb-6 relative">
        <button
          onClick={() => navigate(-1)}
          className="absolute left-0 flex items-center text-teal-700 hover:text-teal-900 font-medium"
        >
          <FaArrowLeft className="mr-2" /> Back
        </button>

        <h1 className="w-full text-center text-3xl font-bold text-gray-800">All Patients</h1>
      </div>

      {/* Flex container for Sign Up button and search input */}
      <div className="flex items-center gap-4 mb-6">

        <input
          type="text"
          placeholder="Search by Name, ABHA Number, or Patient ID"
          value={searchQuery}
          onChange={(e) => handleSearch(e.target.value)}
          className="p-2 w-64 border border-gray-300 rounded-md focus:ring-2 focus:ring-teal-500 focus:outline-none"
        />

      </div>

      <p className="text-sm text-gray-600 mb-6">
        <i>
          Search by ABHA Number, Mobile Number, Patient ID, First Name, ABHA Address
        </i>
      </p>

      {/* Table Section */}
      <div
        className="rounded-lg overflow-hidden shadow-md"
        style={{ backgroundColor: "#DEEBEC" }}
      >
        <div className="flex justify-between items-center p-4">
          <h2 className="text-lg font-bold text-[#0F766E]">Patient Details</h2>
          {/* Button commented out */}
          <button
            className="px-8 py-3 bg-teal-600 text-white font-medium rounded-[10px] focus:ring-teal-500 "
            onClick={() => redirectToSignup()}
          >
            Verify / Register Patient
          </button>
        </div>
        {loading ? (
          <p className="text-center py-4">Loading...</p>
        ) : (
          <table className="w-full table-auto">
            <thead className="bg-[#DEEBEC] border-b border-[#0F766E]">
              <tr>
                <th className="px-4 py-3 text-left text-[15px] font-semibold text-[#0F766E]">Patient ID</th>
                <th className="px-4 py-3 text-left text-[15px] font-semibold text-[#0F766E]">Name</th>
                <th className="px-4 py-3 text-left text-[15px] font-semibold text-[#0F766E]">ABHA Number</th>
                <th className="px-4 py-3 text-left text-[15px] font-semibold text-[#0F766E]">ABHA Address</th>
                <th className="px-4 py-3 text-centre text-[15px] font-semibold text-[#0F766E]">View Profile</th>
                <th className="px-4 py-3 text-centre text-[15px] font-semibold text-[#0F766E]">Upload Records</th>
                <th className="px-4 py-3 text-centre text-[15px] font-semibold text-[#0F766E]">View Records</th>
                <th className="px-4 py-3 text-centre text-[15px] font-semibold text-[#0F766E]">Consent Details</th>
              </tr>
            </thead>
            <tbody>
              {filteredCustomers.map((customer, index) => (
                <tr key={index} className="bg-[#DEEBEC] border-b border-[#C6D9DB]">
                  <td className="px-4 py-3 text-sm font-medium text-gray-700">
                    {customer.patientId}
                  </td>
                  <td className="px-4 py-3 text-sm font-medium text-gray-700">
                    {customer.firstName} {customer.middleName} {customer.lastName}
                  </td>
                  <td className="px-4 py-3 text-sm font-medium text-gray-700">
                    {customer.abhaNumber}
                  </td>
                  <td className="px-4 py-3 text-sm font-medium text-gray-700">
                    {customer.preferredAbhaAddress}
                  </td>
                  <td className="px-4 py-3 text-center font-medium">
                    <span className="flex items-center gap-1 cursor-pointer font-medium text-[#2B98D6]">
                      {customer?.preferredAbhaAddress && (
                        <span
                          onClick={() => handleClickProfile(customer.preferredAbhaAddress)}
                          className="hover:underline text-blue-600 cursor-pointer"
                        >
                          View
                        </span>
                      )}

                      {/* {!customer.validToken && (
                        <div className="relative group m-2">
                          <span
                            className="text-red-600 text-l cursor-default"
                            onClick={() => redirectTo(customer?.mobileNumber)}
                          >
                            <FcHighPriority />
                          </span>
                          <div className="absolute z-10 w-max bg-black text-white text-xs rounded py-1 px-2 opacity-0 group-hover:opacity-100 transition-opacity duration-200 mt-1 left-1/2 transform -translate-x-1/2">
                            {customer?.abhaNumber
                              ? "Token has expired. Kindly re-verify."
                              : "No ABHA number available for this patient."}
                          </div>
                        </div>
                      )} */}
                    </span>


                  </td>
                  <td className="px-4 py-2 text-center">
                    <button onClick={() => handleUploadClick(customer)}>
                      <img src={Cell} alt="Upload Icon" className="w-12 h-12 inline" />
                    </button>
                  </td>
                  <td
                    className="px-4 py-3 text-[#2B98D6] text-center font-medium hover:underline cursor-pointer"
                    onClick={() => handleClick(customer)}
                  >
                    View
                  </td>
                  <td
                    className="px-4 py-3 text-[#2B98D6] text-center font-medium hover:underline cursor-pointer"
                    onClick={() => handleClickconsent(customer)}
                  >
                    View
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        )}
      </div>

      {/* Pagination Section */}
      <div className="flex justify-between items-center mt-4">
        <button
          onClick={() => setPageNumber((prev) => Math.max(prev - 1, 0))}
          disabled={pageNumber === 0}
          className="bg-gray-300 text-gray-700 px-4 py-2 rounded-md hover:bg-gray-400 disabled:opacity-50"
        >
          Previous
        </button>
        <span className="text-gray-700">
          Page {pageNumber + 1} of {totalPages}
        </span>
        <button
          onClick={() =>
            setPageNumber((prev) => (prev + 1 < totalPages ? prev + 1 : prev))
          }
          disabled={pageNumber + 1 >= totalPages}
          className="bg-teal-500 text-white px-4 py-2 rounded-md hover:bg-teal-600"
        >
          Next
        </button>
      </div>

      {/* Modal Section */}
      {modalOpen && (
        <div className="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-50">
          <div className="bg-white dark:bg-gray-800 p-8 rounded-xl shadow-xl w-11/12 max-w-2xl">
            <h2 className="text-3xl font-bold text-gray-900 dark:text-gray-100 mb-6">
              Upload Document
            </h2>
            <div className="mb-5">
              <label className="block text-sm font-medium text-gray-700 dark:text-gray-200 mb-1">
                Organization
              </label>
              <select
                value={selectedSubCentre}
                onChange={(e) => setSelectedSubCentre(e.target.value)}
                className="w-full p-2 rounded-md border border-gray-300 dark:border-gray-700 bg-gray-50 dark:bg-gray-700 text-gray-900 dark:text-gray-100"
              >
                <option value="">Select Organization</option>
                {subCentres.map((c) => (
                  <option key={c.hipId} value={c.hipId}>
                    {c.centerName}
                  </option>
                ))}
              </select>
            </div>

            <div className="mb-5">
              <label className="block text-sm font-medium text-gray-700 dark:text-gray-200 mb-1">
                Document Type
              </label>
              <select
                value={documentType}
                onChange={(e) => setDocumentType(e.target.value)}
                className="w-full p-2 rounded-md border border-gray-300 dark:border-gray-700 bg-gray-50 dark:bg-gray-700 text-gray-900 dark:text-gray-100"
              >
                <option value="">Select Document Type</option>
                <option value="Health Document Record">Health Document Record</option>
                <option value="Prescription">Prescription</option>
                <option value="Diagnostic Report">Diagnostic Report</option>
                <option value="OP Consultation">OP Consultation</option>
                <option value="Invoice">Invoice</option>
                {/* <option value="Discharge Summary">Discharge Summary</option>
            <option value="Immunization Record">Immunization Record</option>
            <option value="Wellness Record">Wellness Record</option> */}

              </select>
            </div>

            <div className="mb-5">
              <label className="block text-sm font-medium text-gray-700 dark:text-gray-200 mb-1">
                About Document
              </label>
              <textarea
                value={aboutDocument}
                onChange={(e) => setAboutDocument(e.target.value)}
                rows="4"
                placeholder="Describe the document here..."
                className="w-full p-2 rounded-md border border-gray-300 dark:border-gray-700 bg-gray-50 dark:bg-gray-700 text-gray-900 dark:text-gray-100"
              />
            </div>

            {documentType === "Health Document Record" && (
              <div className="mb-5">
                <label className="block text-sm font-medium text-gray-700 dark:text-gray-200 mb-1">
                  Select Practitioner
                </label>
                <select
                  value={selectedPractitioner}
                  onChange={(e) => setSelectedPractitioner(e.target.value)}
                  className="w-full p-2 rounded-md border border-gray-300 dark:border-gray-700 bg-gray-50 dark:bg-gray-700 text-gray-900 dark:text-gray-100"
                >
                  <option value="">Select Practitioner</option>
                  {practitioners.map((practitioner) => (
                    <option
                      key={practitioner.healthcareProfessionalId}
                      value={practitioner.healthcareProfessionalId}
                    >
                      {practitioner.name}
                    </option>
                  ))}
                </select>
              </div>
            )}

            <div className="mb-5">
              <label className="block text-sm font-medium text-gray-700 dark:text-gray-200 mb-1">
                Upload File
              </label>
              <input
                type="file"
                onChange={handleFileChange}
                className="w-full p-2 rounded-md border border-gray-300 dark:border-gray-700 bg-gray-50 dark:bg-gray-700 text-gray-900 dark:text-gray-100"
              />
            </div>

            <div className="flex justify-end space-x-4">
              <button
                onClick={handleUpload}
                disabled={uploading}
                className={`flex items-center justify-center bg-teal-500 hover:bg-teal-600 transition-colors duration-200 text-white font-medium py-2 px-4 rounded-md ${uploading ? 'opacity-70 cursor-not-allowed' : ''}`}
              >
                {uploading ? (
                  <svg
                    className="animate-spin h-5 w-5 mr-2 text-white"
                    xmlns="http://www.w3.org/2000/svg"
                    fill="none"
                    viewBox="0 0 24 24"
                  >
                    <circle
                      className="opacity-25"
                      cx="12"
                      cy="12"
                      r="10"
                      stroke="currentColor"
                      strokeWidth="4"
                    ></circle>
                    <path
                      className="opacity-75"
                      fill="currentColor"
                      d="M4 12a8 8 0 018-8v4a4 4 0 00-4 4H4z"
                    ></path>
                  </svg>
                ) : null}
                {uploading ? 'Uploading...' : 'Upload'}
              </button>

              <button
                onClick={closeModal}
                className="bg-gray-300 hover:bg-gray-400 transition-colors duration-200 text-gray-800 font-medium py-2 px-4 rounded-md"
              >
                Cancel
              </button>
            </div>
          </div>
        </div>
      )}

      <ToastContainer />
    </div>

  );
};

export default Viewallcustomers;
